export default "__VITE_ASSET__5Skh5sR4__"